import { Component, ViewChild, Input, Output, EventEmitter,  OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PagePreloaderComponent } from '../../shared/ui/page-preloader/page-preloader.component';
import { Product, InventoryLocation, Report, ReportDetail } from '../shared';

@Component({
    selector: 'products-transfer-selected',
    styles: [ require('./products-transfer-selected.component.scss') ],
    template: require('./products-transfer-selected.component.pug')
})
export class ProductTransferSelectedComponent implements OnInit {
     @ViewChild(PagePreloaderComponent) preloader;

     @Input() products: Array<Product>;
     @Output() deleteProductFromTransfer = new EventEmitter<Product>();

    constructor() {}

    ngOnInit() {
        this.preloader.hide();
    }

    deleteProduct(product) {
      this.products = this.products.filter(p => p.id !== product.id);
      this.deleteProductFromTransfer.emit(product);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/products-transfer-selected/products-transfer-selected.component.ts